import createSagaMiddleware from '@redux-saga/core';
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { all, call } from 'redux-saga/effects';

import { HealthcareApi, MessagingApi, OAuthApi } from '../apis';
import { accountReducer, accountSaga } from '../features/account';
import { appReducer, appSaga } from '../features/app';
import { authReducer, authSaga } from '../features/auth';
import { modalsReducer } from '../features/modals';
import { organizationReducer, organizationSaga } from '../features/organization';
import { patientsReducer, patientsSaga } from '../features/patients';
import { physiologicalDataReducer, physiologicalDataSaga } from '../features/physiological-data';

function getRootReducers() {
  return combineReducers({
    account: accountReducer,
    app: appReducer,
    auth: authReducer,
    modals: modalsReducer,
    organization: organizationReducer,
    patients: patientsReducer,
    physiologicalData: physiologicalDataReducer,
  });
}

function* getRootSagas() {
  const healthcareApi = new HealthcareApi();
  const messagingApi = new MessagingApi();
  const oauthApi = new OAuthApi();
  const effects = [
    call(accountSaga, oauthApi),
    call(appSaga, messagingApi),
    call(authSaga, oauthApi),
    call(patientsSaga, healthcareApi),
    call(organizationSaga, healthcareApi),
    call(physiologicalDataSaga, healthcareApi),
  ];
  yield all(effects);
}

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: getRootReducers(),
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware({ thunk: false }), sagaMiddleware],
});

sagaMiddleware.run(getRootSagas);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
